import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { CardContent, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  tableHeader: {
    background: "#111111",
    height: "100%",
    color: "#fbbbd3",
    fontSize: 14,
  },
  button: {
      background: "#111111",
      color: "#fbbbd3",
      '&:hover': {
          backgroundColor: '#fbbbd3',
          color: '#111111',
      },
  },
  buttonText: {
      color: "#111111",
      '&:hover': {
          backgroundColor: '#fbbbd3',
          color: '#111111',
      },
  },
  text: {
      color: "#111111",
  },
  title: {
      background:"#111111",
  },
}));

function RequestRentAgreementTemp() {
  const classes = useStyles();
  // const [formData, setFormData] = useState([
  //   {
  //     name: 'Cosplay Costume',
  //     rent_price: '100',
  //     deposit: '50',
  //     fullname: '',
  //     address: '',
  //     contact_number: '',
  //     selectedDate: null, // Added selectedDate state
  //   },
  //   {
  //     name: 'Cosplay Costume 2',
  //     rent_price: '200',
  //     deposit: '100',
  //     fullname: '',
  //     address: '',
  //     contact_number: '',
  //     selectedDate: null, // Added selectedDate state
  //   },
  // ]);
  const rows = useSelector((state) => state.requestRentSlice.rows);

  const navigate = useNavigate();

  const totalAmountToPay = rows.reduce((total, row) => {
    return total + (parseFloat(row.rent_price) + parseFloat(row.deposit));
  }, 0);

  const handleProceed = async () => {
    try {
      navigate('/app/request-rent/form');
    } catch (error) {
      console.error('handleRent error:', error);
    }
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });
  // };

  // const shouldDisableDate = (date) => {
  //   const day = date.getDay();
  //   // Disable today, tomorrow, and weekends (Saturday and Sunday)
  //   return day === 0 || day === 6 || date.toDateString() === new Date().toDateString();
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const rentPrice = parseFloat(formData.rent_price);
  //   const deposit = parseFloat(formData.deposit);
  //   const amountToPay = rentPrice + deposit;
  //   console.log('Form Data:', formData);
  //   console.log('Amount to Pay:', amountToPay);
  // };

  return (
    <>
      <Card
        variant="outlined"
        style={{
            marginTop: '5vh',
            padding: '5vh',
        }}
      >
        <Grid container spacing={2}>
          {/* <Grid item xs={4}>
            <CardContent>
              <Grid container spacing={2}>
                <TableContainer component={Paper}>
                  <Table aria-label="customized table">
                      <TableHead>
                          <TableRow>
                              <TableCell align="left" className={classes.tableHeader}></TableCell>
                              <TableCell align="left" className={classes.tableHeader}>Rental Name</TableCell>
                              <TableCell align="left" className={classes.tableHeader}>Rent</TableCell>
                              <TableCell align="left" className={classes.tableHeader}>Deposit</TableCell>
                              <TableCell align="left" className={classes.tableHeader}>Total</TableCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.code}>
                                <TableCell component="th" scope="row">
                                  <CardMedia
                                    component="img"
                                    image={row.item_thumbnail}
                                    alt="PeriCoCo"
                                    style={{ width: '50px', height: '50px' }} // Set the width using the style prop
                                  />
                                </TableCell>
                                <TableCell align="left">{row.name}</TableCell>
                                <TableCell align="left">{row.rent_price}</TableCell>
                                <TableCell align="left">{row.deposit}</TableCell>
                                <TableCell align="left">{parseFloat(row.rent_price) + parseFloat(row.deposit)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Grid item xs={6}>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    {`Note: Pay on meet-up date. Please prepare exact amount.`}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ mb: 1.5 }} variant="h6" className={classes.text} align="right">
                    {`Total Amount to Pay: ${totalAmountToPay}`}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Grid> */}
          <Grid item xs={12}>
          <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography sx={{ mb: 1.5 }} variant="h5" className={classes.text} align="left">
                    Cosplay Wig+Costume Rental Agreement
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    Please read the terms and conditions carefully.
                  </Typography><br/>
                  <Typography sx={{ mb: 1.5 }} variant="h6" className={classes.text} align="left">
                    Cleaning
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    (1) Renter must not wash and clean the wigs and costumes. The owner uses special products to wash and clean the wigs, and costumes are handwashed to prevent wear and tear from the washing machine.
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    (2) In case the renter has styled the wig, the renter must rinse it with water and hang it to air dry. Please avoid placing the wig under direct sunlight.
                  </Typography>

                  <Typography sx={{ mb: 1.5 }} variant="h6" className={classes.text} align="left">
                    Alterations
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    (1) Renter can style the wigs using gel, hairspray, a crimp/hair blower on low heat, and water-based glue.
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    (2) Renter must not cut, trim, or shear the wigs.
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    (3) Renter must not make any adjustments or alterations to the costumes.
                  </Typography>

                  <Typography sx={{ mb: 1.5 }} variant="h6" className={classes.text} align="left">
                    Deposits
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    (1) A security deposit, which is 50% of the item's rental price, is required.
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    (2) The security deposit is per rental item.
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    (3) The security deposit is refundable upon the return of the rented item(s) in good condition.
                  </Typography>

                  <Typography sx={{ mb: 1.5 }} variant="h6" className={classes.text} align="left">
                    Fees
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    (1) Cancellation fee is free when the renter decides to cancel the day before the pick-up date.
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    (2) Cancellation fee is 50 PHP for wigs and 100 PHP for costumes and costume sets when the renter decides to cancel on the day of the pick-up date or before completing the rental duration. In case of when the renter has already paid the rent and deposit, the renter will be refunded (rent+deposit) and will only pay the cancellation fee as long as the items rented are not yet used.
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    (3) Delay to return the rental item will incur 50 PHP for wigs and 100 PHP for costumes and costume sets per day.
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    (4) Damages in any form are subject to additional damage fees. Damage fees depend on the extent of the damage.
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    (5) Irreparable damage is subject to a replacement fee. The replacement fee is the amount needed to procure a replacement for the damaged rental item.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ mb: 1.5 }} className={classes.text} align="left">
                    {`Note: By proceeding with the transaction, you acknowledge that you have read, understood, and agreed to the terms and conditions.`}
                  </Typography>
                </Grid>
                {/* <Grid item xs={12}>
                  <Button type="submit" variant="contained" onClick={handleProceed} color="primary">
                    Proceed
                  </Button>
                </Grid> */}
              </Grid>
            </CardContent>
          </Grid>
        </Grid>
      </Card>
    </>
  )
}

export default RequestRentAgreementTemp;
